module.exports = __webpack_public_path__ + "static/media/start_assessment.54094b66.png";